export default "__VITE_ASSET__24003d2d__"